import React from 'react';

import AnchorLink from '@/components/common/Elements//AnchorLink/AnchorLink';
import Button from '@/components/common/Elements/Button/Button';
import { cn } from '@/util/ui';

const ModalButton = ({ btn, className, onClick, label, disabled = null }) => {
  if (btn === false) {
    return null;
  }

  const defaultButton = (
    <Button
      className={cn(
        'tw-font-brandonTextMedium',
        'tw-mx-[3px] tw-px-[20px] tw-py-[6px]',
        'tw-rounded-[5px] tw-outline-none tw-outline-offset-0',
        'tw-border-solid tw-border-[1px]',
        className,
        disabled && 'disabled'
      )}
      disabled={disabled}
      data-dismiss="modal"
      onClick={!disabled ? onClick : undefined}
    >
      {label}
    </Button>
  );

  if (btn === null) {
    return defaultButton;
  }

  if (btn.component) {
    return btn.component;
  }

  if (btn.link) {
    return (
      <AnchorLink
        href={disabled ? '#' : btn.link}
        className={cn('tw-m-0', className, disabled && 'disabled')}
        data-dismiss="modal"
        onClick={!disabled ? onClick : undefined}
        target={btn.target || null}
      >
        {label}
      </AnchorLink>
    );
  }

  return defaultButton;
};

export default ModalButton;
